import {
  incrementPerUserCount,
  readPerUserCount,
  readPerUserFlag,
  setPerUserFlag,
} from 'components/shared/side-menu/helpers/per-user-local-storage';

import type { NavItemBadgePopover } from 'components/shared/side-menu/nav-config';

export const SIDE_MENU_POPOVER_ANCHOR_ATTRIBUTE =
  'data-side-menu-popover-anchor';

export interface SideMenuPopoverOpenDetail {
  anchorElement?: HTMLElement;
  fallbackAnchorElement?: HTMLElement;
  repositionOnly?: boolean;
  anchorGap?: number;
  onAutoOpened?: () => void;
}

export const MONITORING_INTRO_POPUP_OPEN_EVENT = 'monitoring-intro-popup-open';

export interface SideMenuPopoverConfigEntry {
  trigger: 'badge' | 'item';
  openEvent: string;
  openCountKeyPrefix: string;
}

export const SIDE_MENU_POPOVER_CONFIG = {
  'monitoring-intro': {
    trigger: 'item',
    openEvent: MONITORING_INTRO_POPUP_OPEN_EVENT,
    openCountKeyPrefix: 'mv-monitoring-intro-open-count',
  },
} as const satisfies Record<NavItemBadgePopover, SideMenuPopoverConfigEntry>;

export const dispatchSideMenuPopoverOpen = (
  popover: NavItemBadgePopover,
  detail: SideMenuPopoverOpenDetail = {}
): void => {
  window.dispatchEvent(
    new CustomEvent<SideMenuPopoverOpenDetail>(
      SIDE_MENU_POPOVER_CONFIG[popover].openEvent,
      { detail }
    )
  );
};

export const SIDE_MENU_POPOVER_MAX_AUTO_OPENS = 3;

export const canAutoOpenSideMenuPopover = (
  popover: NavItemBadgePopover,
  oktaUserId: string | undefined
): boolean => {
  if (!oktaUserId) return true;

  return (
    readPerUserCount(
      SIDE_MENU_POPOVER_CONFIG[popover].openCountKeyPrefix,
      oktaUserId
    ) < SIDE_MENU_POPOVER_MAX_AUTO_OPENS
  );
};

export const recordSideMenuPopoverOpen = (
  popover: NavItemBadgePopover,
  oktaUserId: string | undefined
): void => {
  if (!oktaUserId) return;

  incrementPerUserCount(
    SIDE_MENU_POPOVER_CONFIG[popover].openCountKeyPrefix,
    oktaUserId
  );
};

const MARK_INITIAL_WALKTHROUGH_SEEN_KEY_PREFIX =
  'mv-mark-initial-walkthrough-seen';

export const hasSeenMarkInitialWalkthrough = (
  oktaUserId: string | undefined
): boolean => {
  if (!oktaUserId) return false;

  return readPerUserFlag(MARK_INITIAL_WALKTHROUGH_SEEN_KEY_PREFIX, oktaUserId);
};

export const recordMarkInitialWalkthroughSeen = (
  oktaUserId: string | undefined
): void => {
  if (!oktaUserId) return;

  setPerUserFlag(MARK_INITIAL_WALKTHROUGH_SEEN_KEY_PREFIX, oktaUserId);
};
